import { useEffect, useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';

interface SaleCountdownProps {
  endsAt: string;
  compact?: boolean;
}

export const SaleCountdown = ({ endsAt, compact = false }: SaleCountdownProps) => {
  const [timeLeft, setTimeLeft] = useState<string>('');
  
  useEffect(() => {
    const calculateTimeLeft = () => {
      const end = new Date(endsAt).getTime();
      const now = new Date().getTime();
      const diff = end - now;
      
      if (diff <= 0) {
        setTimeLeft('Ended');
        return;
      }
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      
      if (days > 0) {
        setTimeLeft(`${days}d ${hours}h left`);
      } else if (hours > 0) {
        setTimeLeft(`${hours}h ${minutes}m left`);
      } else {
        setTimeLeft(`${minutes}m left`);
      }
    };
    
    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 60000); // Update every minute
    
    return () => clearInterval(interval);
  }, [endsAt]);
  
  if (compact) {
    return (
      <Badge variant="destructive" className="gap-1 text-xs">
        <Clock className="h-3 w-3" />
        {timeLeft}
      </Badge>
    );
  }
  
  return (
    <div className="bg-destructive/10 border border-destructive/20 p-2 rounded flex items-center gap-2 text-sm">
      <Badge variant="destructive" className="text-xs">SALE</Badge>
      <Clock className="h-4 w-4 text-destructive" />
      <span className="font-semibold text-destructive">{timeLeft}</span>
    </div>
  );
};
